export enum Insurer {
  EMPIRE = 'EMPIRE',
  UV = 'UV',
  HUMANIA = 'HUMANIA',
  BENEVA = 'BENEVA',
  CPP = 'CPP',
  IA = 'IA',
  MANULIFE = 'MANULIFE',
  SUN_LIFE = 'SUN_LIFE',
  IVARI = 'IVARI',
  BMO = 'BMO',
  ASSUMPTION = 'ASSUMPTION',
  BLUE_CROSS = 'BLUE_CROSS',
  CANADA_LIFE = 'CANADA_LIFE',
  EXCELLENCE = 'EXCELLENCE',
  SLI = 'SLI',
  FORESTERS = 'FORESTERS',
  RBC = 'RBC',
  UNKNOWN = 'UNKNOWN',
}

export const BACKEND_INSURER_TO_INSURER = new Map([
  ['Empire Life', Insurer.EMPIRE],
  ['Union Life Mutual', Insurer.UV],
  ['Humania', Insurer.HUMANIA],
  ['Beneva', Insurer.BENEVA],
  ['CPP Underwriting', Insurer.CPP],
  ['IA Financial', Insurer.IA],
  ['Manulife', Insurer.MANULIFE],
  ['Sun Life', Insurer.SUN_LIFE],
  ['Ivari', Insurer.IVARI],
  ['BMO Insurance', Insurer.BMO],
  ['ASSUMPTION', Insurer.ASSUMPTION],
  ['Assumption Life', Insurer.BLUE_CROSS],
  ['Canada Life', Insurer.CANADA_LIFE],
  ['IA Excellence', Insurer.EXCELLENCE],
  ['RBC Insurance', Insurer.RBC],
]);
